import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { getDamagedCustomerAttachedDocumentImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedDocumentImages/getDamagedCustomerAttachedDocumentImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const CustomerDocumentImagesTab = () => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedCustomerAttachedDocumentImagesQueryOptions({
      damaged_id: Number(damagedId),
      id: Number(id),
    }),
  );
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر مدارک
      </Typography>
      {imagesData?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر دور تا دور وسیله‌نقلیه
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.map((image, index) => {
              return (
                <ImageCard
                  key={image.id}
                  imageData={{
                    name: ImagesListName({
                      titleType: 'attachment',
                      index,
                    }),
                    src: image.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
    </>
  );
};

export default CustomerDocumentImagesTab;
